import { CommonProp } from '@acin/ui-core';
import React from 'react';

interface IContext {
  // The draggable reg-text viewer is hidden by default and toggled open by the user.
  regTextModalIsOpen: boolean;
  // The segment whose regulatory text should be shown.
  activeSegmentId?: string;
  // The fragment group to highlight / scroll into view within that segment.
  activeFragmentId?: string;
  onToggleRegTextModal: () => void;
  onUpdateActiveSegmentId: (segmentId?: string) => void;
  onUpdateActiveFragmentId: (fragmentId?: string) => void;
}

export const INITIAL_STATE: IContext = {
  regTextModalIsOpen: false,
  activeSegmentId: undefined,
  activeFragmentId: undefined,
  onToggleRegTextModal: () => {},
  onUpdateActiveSegmentId: () => {},
  onUpdateActiveFragmentId: () => {},
};

export const Context = React.createContext(INITIAL_STATE);

export const useRegTextViewer = () => React.useContext(Context);

export const RegTextProvider: React.FC<CommonProp> = ({ children }) => {
  const [regTextModalIsOpen, setRegTextModalIsOpen] = React.useState(false);
  const [activeSegmentId, setActiveSegmentId] = React.useState<string | undefined>();
  const [activeFragmentId, setActiveFragmentId] = React.useState<string | undefined>();

  const onToggleRegTextModal = React.useCallback(() => {
    setRegTextModalIsOpen((prev) => !prev);
  }, []);

  const onUpdateActiveSegmentId = React.useCallback((segmentId?: string) => {
    setActiveSegmentId(segmentId);
  }, []);

  const onUpdateActiveFragmentId = React.useCallback((fragmentId?: string) => {
    setActiveFragmentId(fragmentId);
  }, []);

  return (
    <Context.Provider
      value={{
        regTextModalIsOpen,
        activeSegmentId,
        activeFragmentId,
        onToggleRegTextModal,
        onUpdateActiveSegmentId,
        onUpdateActiveFragmentId,
      }}
    >
      {children}
    </Context.Provider>
  );
};
